import { Component, OnInit, OnDestroy, TemplateRef, ViewChild } from '@angular/core'
import { AngularRoutes, ContractStatus, ExceptionAlert, Subscription } from '@parkupp/core'
import { DocumentData, Query } from '@angular/fire/firestore'
import { GlobalService } from '../../../services/global.service'
import { ActivatedRoute, Router } from '@angular/router'
import { AdminService } from '../../../services/admin.service'
import { ExceptionAlertService } from '../../../services/exception-alert.service'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { Subscription as RxSubscription } from 'rxjs'

@Component({
    selector: 'app-admin-list-exceptions',
    templateUrl: './admin-list-exceptions.component.html',
    styleUrls: ['./admin-list-exceptions.component.scss'],
})
export class AdminListExceptionsComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[]
    inactiveContractStatuses: ContractStatus[]
    ref: Query<DocumentData>
    status: string
    readonly AngularRoutes = AngularRoutes
    exceptionAlerts: ExceptionAlert[] = []
    lastVisible: any
    showLoadMoreButton: boolean = true
    reviewed: boolean = false

    // Modal and subscription properties
    @ViewChild('exceptionDetailModal') exceptionDetailModal: TemplateRef<any>
    modalRef: BsModalRef
    selectedExceptionAlert: ExceptionAlert | null = null
    exceptionAlertsSubscription: RxSubscription

    constructor(
        public globalService: GlobalService,
        private route: ActivatedRoute,
        private router: Router,
        private adminService: AdminService,
        private exceptionAlertService: ExceptionAlertService,
        private modalService: BsModalService
    ) {}

    ngOnInit() {
        this.reviewed = false
        this.loadExceptionAlerts()
    }

    ngOnDestroy() {
        if (this.exceptionAlertsSubscription) {
            this.exceptionAlertsSubscription.unsubscribe()
        }
    }

    loadExceptionAlerts() {
        // Unsubscribe from previous subscription if exists
        if (this.exceptionAlertsSubscription) {
            this.exceptionAlertsSubscription.unsubscribe()
        }

        // Subscribe to real-time updates
        this.exceptionAlertsSubscription = this.exceptionAlertService.subscribe({ reviewed: this.reviewed }).subscribe((alerts) => {
            this.exceptionAlerts = alerts
        })
    }

    async loadMore() {
        // For backward compatibility, keeping this method but it now just calls loadExceptionAlerts
        this.loadExceptionAlerts()
    }

    async markAllAsReviewed() {
        if (confirm('Are you sure you want to mark all alerts as reviewed?')) {
            await this.exceptionAlertService.markAllAsReviewed()
            // No need to manually reload as subscription will handle updates
        }
    }

    onReviewedChange(event: Event) {
        const value = (event.target as HTMLSelectElement).value
        this.reviewed = value === 'true'
        this.loadExceptionAlerts()
    }

    async markAsReviewed(key: string) {
        await this.exceptionAlertService.markAsReviewed(key)
        // No need to manually reload as subscription will handle updates
    }

    async markAsUnreviewed(key: string) {
        await this.exceptionAlertService.markAsUnreviewed(key)
        // No need to manually reload as subscription will handle updates
    }

    // Modal methods
    viewExceptionDetails(alert: ExceptionAlert) {
        this.selectedExceptionAlert = alert
        this.modalRef = this.modalService.show(this.exceptionDetailModal, { class: 'modal-lg' })
    }

    closeModal() {
        if (this.modalRef) {
            this.modalRef.hide()
        }
        this.selectedExceptionAlert = null
    }

    getSeverityClass(severity: string) {
        switch (severity) {
            case 'critical':
                return 'bg-danger'
            case 'high':
                return 'bg-warning'
            case 'info':
                return 'bg-info'
            case 'low':
                return 'bg-secondary'
            default:
                return 'bg-secondary'
        }
    }

    // Helper method to get formatted JSON
    getFormattedJson(jsonString: string): string {
        try {
            const parsed = JSON.parse(jsonString)
            return JSON.stringify(parsed, null, 2)
        } catch (e) {
            return jsonString
        }
    }
}
